// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__14CL3","topBottomGutter":"Layout_topBottomGutter__2WPmY"};